"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT = exports.SEGMENTS = void 0;
const route_1 = require("../route");
const menu_1 = require("./menu");
exports.SEGMENTS = route_1.PROJECT.sub("/segments");
exports.SEGMENT = route_1.PROJECT.sub("/segments/:segmentId", undefined, {
    components: { menu: menu_1.SegmentMenu },
});
